module.exports = __webpack_public_path__ + "img/photo-0110.47f944aa.jpg";